import React from "react";

function FootageSearch({ onSearchBy, searchBy, primaryKey }) {
  return (
    <div className="">
      ค้นหาโดยใช้&nbsp;
      <label class="inline-flex items-center lg:ml-2">
        <input
          onChange={() => onSearchBy(primaryKey)}
          type="radio"
          class="form-radio"
          name="search"
          defaultChecked={true}
          checked={searchBy === primaryKey}
        />
        <span class="ml-2">Job No.</span>
      </label>
      <label class="inline-flex items-center ml-2">
        <input
          onChange={() => onSearchBy("name")}
          type="radio"
          class="form-radio"
          name="search"
          checked={searchBy === "name"}
        />
        <span class="ml-2">ชื่อ - นามสกุล</span>
      </label>
      <label class="inline-flex items-center ml-2">
        <input
          onChange={() => onSearchBy("requestamount")}
          type="radio"
          class="form-radio"
          name="search"
          checked={searchBy === "requestamount"}
        />
        <span class="ml-2">วงเงินที่ได้</span>
      </label>
      <label class="inline-flex items-center ml-2">
        <input
          onChange={() => onSearchBy("adminName")}
          type="radio"
          class="form-radio"
          name="search"
          checked={searchBy === "adminName"}
        />
        <span class="ml-2">ชื่อแอดมิน</span>
      </label>
      <label class="inline-flex items-center ml-2">
        <input
          onChange={() => onSearchBy("phone_number")}
          type="radio"
          class="form-radio"
          name="search"
          checked={searchBy === "phone_number"}
        />
        <span class="ml-2">เบอร์โทร</span>
      </label>
      <label class="inline-flex items-center ml-2">
        <input
          onChange={() => onSearchBy("citizenid")}
          type="radio"
          class="form-radio"
          name="search"
          checked={searchBy === "citizenid"}
        />
        <span class="ml-2">บัตรประชาชน</span>
      </label>
      <label class="inline-flex items-center ml-2">
        <input
          onChange={() => onSearchBy("plate")}
          type="radio"
          class="form-radio"
          name="search"
          checked={searchBy === "plate"}
        />
        <span class="ml-2">ทะเบียนรถ</span>
      </label>
    </div>
  );
}

export default FootageSearch;
